import { render, staticRenderFns } from "./nrel-header.vue?vue&type=template&id=5e23fc48&"
import script from "./nrel-header.vue?vue&type=script&lang=js&"
export * from "./nrel-header.vue?vue&type=script&lang=js&"
import style0 from "./nrel-header.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports